var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"el-icon-copy-document fortress-copy",staticStyle:{"padding-left":"2px","cursor":"pointer"},attrs:{"data-clipboard-text":_vm.copyData},on:{"click":function($event){return _vm.copy($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }